module.exports = __webpack_public_path__ + "img/logo1 (20).36352e00.jpg";